import { Link } from "react-router-dom";
import { works } from "@/mocks/works";
import SectionHeading from "@/components/feature/SectionHeading";
import WorkCard from "@/components/feature/WorkCard";

export default function NewReleases() {
  const releases = [...works].sort((a, b) => (a.isNew === b.isNew ? 0 : a.isNew ? -1 : 1)).slice(0, 8);

  return (
    <section className="bg-background-50 py-12 md:py-16" aria-label="新番上架速递">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="新番上架速递"
          title="每日新作 · 第一时间上架"
          desc="新番抢先看、首发不缺席，热门新漫每日更新速递。"
          action={
            <Link
              to="/new-releases"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
            >
              查看全部新作 <i className="ri-arrow-right-line" />
            </Link>
          }
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
          {releases.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}